/* eslint-disable @typescript-eslint/ban-ts-comment */

import { popPageManager } from '@/shared/tools/popPageManager';
import LivenessSaveDialog from './LivenessSavePopup';


let instance: LivenessSaveDialog;

export function showLivenessSavePopup(title: string, scene?: string): Promise<void> {
  if (!instance) {
    instance = new LivenessSaveDialog().$mount();
    document.body.appendChild(instance.$el);
  }

  // @ts-ignore
  popPageManager.addShowedPop(instance);

  return instance.open(title, scene);
}
